<app-common-modal-form
  [header]="'Entities synchronisation with ' + (ExternalSourceType[sourceType] | toUpperStr)"
  [icon]="''"
  [closeText]="'Cancel'"
  (close)="onClose()"
  (confirm)="sync()"
  [isLoading]="isLoading"
>
<div class="body-container d-flex flex-column gap-12 mrgb-05r">

  <div class="message">Please choose the type of entity you want to synchronise with {{ExternalSourceType[sourceType] | toUpperStr}}.</div>
    
  @for (type of typeList; track type) {
    
      <app-checkbox
        [label]="type.name"
        [value]="type.checked"
        (change)="type.checked = $event"
      ></app-checkbox>
  }
</div>
</app-common-modal-form>

